// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.getstarted_container_getstarted__XsdAB {
  width: 100%;
  margin-left: 0%;
  /* width: 100%; */
  height: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column; 
}

.getstarted_container_thankyou__nnz6I {
  width: 100%;
  margin-left: 0%;
  margin-bottom: 5%;
  /* width: 100%; */
  height: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column; 
}

.getstarted_container_getstarted_body__NcUJ7 {
  margin-left: 20%;
  align-items: flex-start;
  align-content: flex-start;
}

.getstarted_disabledCursor__9AqIt { 
  cursor: default;
}

.getstarted_bottom_right_buttons__LXHYX {
  display: flex;
  align-items: flex-end;
  align-content: flex-end;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 0%;
  margin-left: 23%;
  margin-bottom: 1%;
}

.getstarted_input_getstarted_details__baIJR {
  width: 100%;
  border-radius: 15px;
  border: 0.5px solid; 
}

.getstarted_input_getstarted_email__Fng\\+W {
  width: 100%;
  border-radius: 15px;
  border: 0.5px solid; 
}

.getstarted_home_icon__Ym2QY{
  margin-right: 5px;
  font-size: 20px !important;
}

.getstarted_hintTitle__FaMG9 {
    font-family: var(--bookFontFamily);
    color: var(--hsrcDarkBlue);
    font-size: 24px;
    font-style: bold;
    font-weight: 700;
    line-height: 63px;
    letter-spacing: 0.07em;
    text-align: left;
}


.getstarted_hintText__Q9ZDt {
    font-family: var(--bookFontFamily);
    color: var(--hsrcMidBlue);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0.07em;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/HintCard/getstarted.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB","sourcesContent":[".container_getstarted {\r\n  width: 100%;\r\n  margin-left: 0%;\r\n  /* width: 100%; */\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  flex-direction: column; \r\n}\r\n\r\n.container_thankyou {\r\n  width: 100%;\r\n  margin-left: 0%;\r\n  margin-bottom: 5%;\r\n  /* width: 100%; */\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  flex-direction: column; \r\n}\r\n\r\n.container_getstarted_body {\r\n  margin-left: 20%;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n}\r\n\r\n.disabledCursor { \r\n  cursor: default;\r\n}\r\n\r\n.bottom_right_buttons {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  align-content: flex-end;\r\n  justify-content: flex-end;\r\n  flex-direction: row;\r\n  margin-top: 0%;\r\n  margin-left: 23%;\r\n  margin-bottom: 1%;\r\n}\r\n\r\n.input_getstarted_details {\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  border: 0.5px solid; \r\n}\r\n\r\n.input_getstarted_email {\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  border: 0.5px solid; \r\n}\r\n\r\n.home_icon{\r\n  margin-right: 5px;\r\n  font-size: 20px !important;\r\n}\r\n\r\n.hintTitle {\r\n    font-family: var(--bookFontFamily);\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 24px;\r\n    font-style: bold;\r\n    font-weight: 700;\r\n    line-height: 63px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}\r\n\r\n\r\n.hintText {\r\n    font-family: var(--bookFontFamily);\r\n    color: var(--hsrcMidBlue);\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 36px;\r\n    letter-spacing: 0.07em;\r\n    text-align: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_getstarted": `getstarted_container_getstarted__XsdAB`,
	"container_thankyou": `getstarted_container_thankyou__nnz6I`,
	"container_getstarted_body": `getstarted_container_getstarted_body__NcUJ7`,
	"disabledCursor": `getstarted_disabledCursor__9AqIt`,
	"bottom_right_buttons": `getstarted_bottom_right_buttons__LXHYX`,
	"input_getstarted_details": `getstarted_input_getstarted_details__baIJR`,
	"input_getstarted_email": `getstarted_input_getstarted_email__Fng+W`,
	"home_icon": `getstarted_home_icon__Ym2QY`,
	"hintTitle": `getstarted_hintTitle__FaMG9`,
	"hintText": `getstarted_hintText__Q9ZDt`
};
export default ___CSS_LOADER_EXPORT___;
